import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, calc(-50% + 0.5px));
	display: flex;
	flex-direction: column;
	gap: 20px;
	width: 460px;
	padding: 30px;
	background: #111314;
	box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);
	border-radius: 10px;
`;

const StyledText = styled(Text)`
	font-size: 16px;
	color: #ffffff;
	text-align: center;
	opacity: 0.75;
`;

const StyledButton = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	height: 60px;
	background: linear-gradient(95.95deg, #943411 0%, #ff8800 100%);
	border-radius: 5px;
	cursor: pointer;

	&::before {
		content: '';
		position: absolute;
		inset: 0;
		background: #ffffff;
		border-radius: 5px;
		opacity: 0;
		pointer-events: none;
		transition: opacity 0.3s ease;
	}

	&::after {
		content: '';
		position: absolute;
		inset: 0;
		border: 1px solid rgba(255, 255, 255, 0.25);
		border-radius: 5px;
		pointer-events: none;
		transition: border-color 0.3s ease;
	}

	${Text} {
		position: relative;
		font-weight: 500;
		font-size: 18px;
		color: #ffffff;
		transition: color 0.3s ease;
	}

	.img-icon {
		position: relative;
		transition: background-color 0.3s ease;
	}

	&:hover {
		&::before {
			opacity: 1;
		}

		&::after {
			border-color: #ffffff;
		}

		${Text} {
			color: #000000;
		}

		.img-icon {
			background-color: #000000;
		}
	}
`;

const StyledNote = styled(Text)`
	font-size: 16px;
	color: #ffffff;
	text-align: center;
	opacity: 0.25;
`;

export { StyledButton, StyledContainer, StyledNote, StyledText };
